import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://rxjxmpivepxgjqladwrl.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ4anhtcGl2ZXB4Z2pxbGFkd3JsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQzOTQzNjgsImV4cCI6MjA1OTk3MDM2OH0.r7_kmQvC-rIaNXZ5woxDNpnG4NZ1C4_l6fuLKBpr018';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
